"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // The bare `captureException(error)` this replaced is why THE-SUKHA-COMPANY-RX could
    // not be acted on: a browser-thrown `TypeError` with no stack, no route and no digest.
    // Anything reaching the root boundary has already cost the member the whole page, so
    // the report has to carry enough to find out why.
    Sentry.captureException(error, {
      contexts: {
        sukha: {
          boundary: "root",
          digest: error?.digest ?? null,
          route:
            typeof window === "undefined" ? null : window.location.pathname,
        },
      },
    });
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}